import BaseModel from './base-model';
/**
 * format:
 */
export default class SurveyAnswer extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.puntuation = (opts.sequence / 10) || null;
  }
}
